const DEFAULT_FADE_DURATION = 0.5;
const DEFAULT_TELEPORT_DELAY = 0.8;

export { DEFAULT_FADE_DURATION, DEFAULT_TELEPORT_DELAY };
